import { isVariantOf, ComponentsVariants } from '@/components.variants';
import resolveImage from '../resolveImage';
import resolveLink from '../resolveLink';

export const isHorizontalButtonSet = isVariantOf(ComponentsVariants.HORIZONTAL_BUTTON_SET, true);

export default (ravVal: any, page: any, pageModels: any) => {
  const { buttonGroup = [], groupTitle } = ravVal;
  return {
    variant: ComponentsVariants.HORIZONTAL_BUTTON_SET,
    title: groupTitle,
    contentList: buttonGroup.map(({ buttonIcon, button }: any) => ({
      image: resolveImage({ rawVal: buttonIcon, page }),
      link: resolveLink({ rawVal: button, page, pageModels }),
    })),
  };
};
